import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import { Hooks, Util } from "@xt/xtbase";
const { useTranslation } = Hooks;
import cx from "classnames";
const { getUrl } = Util;
import store from "store";
import { LayoutEnum } from "store/app";
import { get_currencyCgSupported } from "api/v4/price";

import { Drawer, message } from "antd";
import XtFontScale from "components/xt/fontScale";
import XtSvg from "components/xt/svg";

import CMPT_MarketTip from "../marketTip";
import CPMT_market from "../../market";
import CurrencyInfo from "../currencyInfo";

import styles from "./index.module.scss";

const Main: React.FC = () => {
  const t = useTranslation();
  const { isH5 } = store.app;
  const { name, isLever, leverConfigObj } = store.market;
  /*
  const { currencyObj } = store.currency;
  const curCurrencyDoc = useMemo(() => {
    if (!currencyObj) return;
    return currencyObj[name.split("_")[0]];
  }, [name, currencyObj]);
  const refCgSupported = useRef<WithUndefined<boolean>>();
  const handleClickMore = useCallback(() => {
    if (!curCurrencyDoc) return;
    if (refCgSupported.current === undefined) {
      get_currencyCgSupported(curCurrencyDoc.currency).then((data) => {
        refCgSupported.current = !!data;
        todo();
      });
    } else {
      todo();
    }

    function todo() {
      if (refCgSupported.current) {
        location.href = getUrl("/price/" + curCurrencyDoc?.currency);
      } else {
        message.warn(t("price.currencyCgNotSupport"));
      }
    }
  }, [curCurrencyDoc]);
   */

  const [open, setOpen] = useState(false);
  const onClose = useCallback(() => {
    setOpen(false);
  }, []);
  useEffect(() => {
    onClose();
  }, [isH5, name, isLever]);

  const marketName = useMemo(() => {
    return store.market.formatName(name);
  }, [name]); // eslint-disable-line react-hooks/exhaustive-deps

  const tag: WithUndefined<string> = useMemo(() => {
    if (!isLever) return;
    if (leverConfigObj && leverConfigObj[name]) {
      return leverConfigObj[name].maxLeverage + "X";
    }
  }, [name, isLever, leverConfigObj]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={styles.main}>
      <div className={styles.title} onClick={() => isH5 && setOpen(true)}>
        {isH5 ? (
          <XtFontScale isLoop>
            <h1>{marketName}</h1>
          </XtFontScale>
        ) : (
          <h1>{marketName}</h1>
        )}
        {!!tag && <div className={styles.tag}>{tag}</div>}

        {!isH5 && store.app.layout !== LayoutEnum.classic && (
          <div className={cx(styles.pop, { [styles.popTip]: store.trade.isMaintainTip })}>
            <CPMT_market clsSearch={styles.search} />
          </div>
        )}
      </div>
      <div className={styles.desc}>
        {/*{!!curCurrencyDoc && (*/}
        {/*  <div className={styles.info} onClick={handleClickMore}>*/}
        {/*    <XtSvg icon="info" />*/}
        {/*    <h2>{curCurrencyDoc.fullName || curCurrencyDoc.currency.toUpperCase()}</h2>*/}
        {/*  </div>*/}
        {/*)}*/}

        <CurrencyInfo />
        <CMPT_MarketTip />
      </div>

      {isH5 && (
        <Drawer
          className={styles.drawer}
          closable={false}
          title={t("trade.market2")}
          placement="bottom"
          height="80vh"
          open={open}
          onClose={onClose}
          extra={
            <button className={cx("btnTxt", "btnHover")} onClick={onClose}>
              <XtSvg icon={`close`} />
            </button>
          }
        >
          <CPMT_market clsSearch={styles.search} />
        </Drawer>
      )}
    </div>
  );
};

export default observer(Main);
